// 单据状态常量
export const ORDERSTATE = {
  DRAFT: 1, // 草稿
  WAIT: 4,
  PART: 5,
  END: 2,
  WAITPURCHASE: 2, // 采购待入库
  PARTPURCHASE: 3, // 采购部分入库
  ENDPURCHASE: 4, // 已采购
  WAITSTOREW: 1, // 物料待出库、待入库
  PARTSTOREW: 2, // 物料部分出库、部分入库
  ENDSTOREW: 3, // 物料完成待出库、完成待入库
  GIVESTOREW: 4, // 物料放弃出库、放弃入库
  ENDSTORE: 2, // 物料已出库、已入库
  WAITOUTBOUNDPICK: 3, // 领料待出库、待入库
  PARTOUTBOUNDPICK: 4, // 领料部分出库、部分入库
  ENDOUTBOUNDPICK: 2, // 已领料、已退料
  WAITOUTBOUND: 4, // 生产待出库
  PARTOUTBOUND: 5, // 生产部分出库
  ENDINVENTORY: 2, // 物料已盘点
  ENDOUTBOUND: 2, // 成品已出库
  PARTFINISHOUTBOUND: 45, // 成品调拨部分出库
  REVOKE: 9, // 撤销
  RETAILlWAIT: 2, // 采购退货待出库
  RETAILlPART: 3, // 采购退货部分出库
  RETAILEND: 4, // 采购退货已退货
  WAITDELIVERY: 2, // 物料发货 待收货
  ENDELIVERY: 4, // 物料发货 已收货
  ENDSTOREIN: 6, // 次品返厂结束入库
  REFUSEEXAMINE: -3, // 物料发料拒绝审核
  CANCELEXAMINE: -2, // 物料发料取消审核
  WAITEXAMINE: -1, // 物料发料待审核
  PROCESSAUDITWAITSUBMIT: 0, // 工序审核待提交
  PROCESSAUDITWAITAUDIT: 1, // 工序审核待审核
  PROCESSAUDITCONSENT: 5, // 工序审核已同意
  PROCESSAUDITREJECT: 9, // 工序审核已拒绝
};
// 库存流水单据状态常量
// export const stockFlowState = [
//   { val: 11, text: '生产入库' },
//   { val: 21, text: '生产出库' },
//   { val: 12, text: '成品入库' },
//   { val: 22, text: '成品出库' },
//   { val: 13, text: '成品待入库-生产入库' },
//   { val: 14, text: '成品待入库-成品调拨' },
//   { val: 23, text: '成品待出库-生产出库' },
//   { val: 24, text: '成品待出库-成品调拨' },
//   { val: 31, text: '成品调拨' },
//   { val: 41, text: '成品盘点' }
// ]
// 物料盘点单据状态常量
export const materialInventoryState = [
  { val: ORDERSTATE.DRAFT, text: '草稿', color: 'plainBlue' },
  { val: ORDERSTATE.ENDINVENTORY, text: '已盘点', color: 'green' },
  { val: ORDERSTATE.REVOKE, text: '已撤销', color: 'gray' },
];
// 成品盘点单据状态常量
export const finishedInventoryState = [
  { val: ORDERSTATE.DRAFT, text: '草稿', color: 'plainBlue' },
  { val: ORDERSTATE.ENDINVENTORY, text: '已盘点', color: 'green' },
  { val: ORDERSTATE.REVOKE, text: '已撤销', color: 'gray' },
];
// 成品调拨单据状态常量
export const finishedTransferState = [
  { val: ORDERSTATE.DRAFT, text: '草稿', color: 'plainBlue' },
  { val: ORDERSTATE.WAITOUTBOUND, text: '待出库', color: 'yellow' },
  { val: ORDERSTATE.PARTOUTBOUND, text: '待入库', color: 'yellow' },
  { val: ORDERSTATE.PARTFINISHOUTBOUND, text: '待出入库', color: 'orange' },
  { val: ORDERSTATE.ENDINVENTORY, text: '完成', color: 'green' },
  { val: ORDERSTATE.REVOKE, text: '已撤销', color: 'gray' },
];
// 物料采购单据状态常量
export const materialPurchaseState = [
  { val: ORDERSTATE.DRAFT, text: '草稿', color: 'plainBlue' },
  { val: ORDERSTATE.WAITPURCHASE, text: '待入库', color: 'orangeRed' },
  { val: ORDERSTATE.PARTPURCHASE, text: '部分入库', color: 'yellow' },
  { val: ORDERSTATE.ENDPURCHASE, text: '已采购', color: 'green' },
  { val: ORDERSTATE.REVOKE, text: '已撤销', color: 'gray' },
];

// 物料待入库单据状态常量
export const materialStoreWinState = [
  { val: ORDERSTATE.WAITSTOREW, text: '待入库', color: 'orangeRed' },
  { val: ORDERSTATE.PARTSTOREW, text: '部分入库', color: 'yellow' },
  { val: ORDERSTATE.ENDSTOREW, text: '已入库', color: 'green' },
  { val: ORDERSTATE.GIVESTOREW, text: '放弃入库', color: 'plainBlue' },
  { val: ORDERSTATE.REVOKE, text: '已撤销', color: 'gray' },
];
export const materialStoreInState = [
  { val: ORDERSTATE.ENDSTORE, text: '已入库', color: 'green' },
  { val: ORDERSTATE.REVOKE, text: '已撤销', color: 'gray' },
];
export const materialStoreWoutState = [
  { val: ORDERSTATE.WAITSTOREW, text: '待出库', color: 'orangeRed' },
  { val: ORDERSTATE.PARTSTOREW, text: '部分出库', color: 'yellow' },
  { val: ORDERSTATE.ENDSTOREW, text: '已出库', color: 'green' },
  { val: ORDERSTATE.GIVESTOREW, text: '放弃出库', color: 'plainBlue' },
  { val: ORDERSTATE.REVOKE, text: '撤销', color: 'gray' },
];
export const materialStoreOutState = [
  { val: ORDERSTATE.ENDSTORE, text: '已出库', color: 'green' },
  { val: ORDERSTATE.REVOKE, text: '撤销', color: 'gray' },
];
// 物料调拨单据状态常量
export const materialTransferState = [
  { val: ORDERSTATE.DRAFT, text: '草稿', color: 'blue' },
  { val: ORDERSTATE.WAITOUTBOUND, text: '待出库', color: 'yellow' },
  { val: ORDERSTATE.PARTOUTBOUND, text: '待入库', color: 'yellow' },
  { val: ORDERSTATE.PARTFINISHOUTBOUND, text: '待出入库', color: 'orange' },
  { val: ORDERSTATE.ENDINVENTORY, text: '完成', color: 'green' },
  { val: ORDERSTATE.REVOKE, text: '已撤销', color: 'gray' },
];
// 领料 or 退料
export const pickOrderType = {
  PICK: 1, // 领料
  RETURN: 2, // 退料
};
// 物料领料单据状态常量
export const materialPickingState = [
  { val: ORDERSTATE.DRAFT, text: '草稿', color: 'blue' },
  { val: ORDERSTATE.WAITOUTBOUNDPICK, text: '待出库', color: 'orangeRed' },
  { val: ORDERSTATE.PARTOUTBOUNDPICK, text: '部分出库', color: 'orange' },
  { val: ORDERSTATE.ENDOUTBOUNDPICK, text: '已领料', color: 'green' },
  { val: ORDERSTATE.REVOKE, text: '已撤销', color: 'gray' },
];
// 物料退料单据状态常量
export const materialReturnState = [
  { val: ORDERSTATE.DRAFT, text: '草稿', color: 'blue' },
  { val: ORDERSTATE.WAITOUTBOUNDPICK, text: '待入库', color: 'orangeRed' },
  { val: ORDERSTATE.PARTOUTBOUNDPICK, text: '部分入库', color: 'orange' },
  { val: ORDERSTATE.ENDOUTBOUNDPICK, text: '已退料', color: 'green' },
  { val: ORDERSTATE.REVOKE, text: '已撤销', color: 'gray' },
];
// 商品出库单据状态常量
export const outboundOrderState = [
  { val: ORDERSTATE.DRAFT, text: '草稿', color: 'blue' },
  { val: ORDERSTATE.WAITOUTBOUND, text: '待出库', color: 'orangeRed' },
  { val: ORDERSTATE.PARTOUTBOUND, text: '部分出库', color: 'orange' },
  { val: ORDERSTATE.ENDOUTBOUND, text: '已出库', color: 'green' },
  { val: ORDERSTATE.REVOKE, text: '撤销', color: 'gray' },
];
// 次品返厂单据状态常量
export const goodsReworkOrderState = [
  { val: ORDERSTATE.DRAFT, text: '草稿', color: 'blue' },
  { val: ORDERSTATE.WAIT, text: '待入库', color: 'orangeRed' },
  { val: ORDERSTATE.PARTOUTBOUND, text: '部分入库', color: 'orange' },
  { val: ORDERSTATE.END, text: '已入库', color: 'green' },
  { val: ORDERSTATE.ENDSTOREIN, text: '结束入库', color: 'red' },
  { val: ORDERSTATE.REVOKE, text: '撤销', color: 'gray' },
];
// 借还单据状态常量
export const borrowOrderState = [
  { val: ORDERSTATE.WAIT, text: '待归还', color: 'orangeRed' },
  { val: ORDERSTATE.PART, text: '部分归还', color: 'orange' },
  { val: ORDERSTATE.END, text: '已归还', color: 'green' },
  { val: ORDERSTATE.REVOKE, text: '已撤销', color: 'gray' },
];
// 归还单据状态常量
export const backOrderState = [
  { val: ORDERSTATE.END, text: '已归还', color: 'green' },
  { val: ORDERSTATE.REVOKE, text: '已撤销', color: 'gray' },
];
// 采购退货单据状态常量
export const purchaseRetailState = [
  { val: ORDERSTATE.DRAFT, text: '草稿', color: 'blue' },
  { val: ORDERSTATE.RETAILlWAIT, text: '待出库', color: 'orangeRed' },
  { val: ORDERSTATE.RETAILlPART, text: '部分出库', color: 'orange' },
  { val: ORDERSTATE.RETAILEND, text: '已退货', color: 'green' },
  { val: ORDERSTATE.REVOKE, text: '撤销', color: 'gray' },
];
// 物料发货单据状态常量
export const deliveryOrderState = [
  { val: ORDERSTATE.WAITDELIVERY, text: '待收货', color: 'orangeRed' },
  { val: ORDERSTATE.ENDELIVERY, text: '已收货', color: 'green' },
];
// 物料发料单据状态常量
export const materialSendState = [
  { val: ORDERSTATE.DRAFT, text: '草稿', color: 'blue' },
  { val: ORDERSTATE.WAITEXAMINE, text: '待审核', color: 'yellow' },
  { val: ORDERSTATE.WAITOUTBOUND, text: '待出库', color: 'yellow' },
  { val: ORDERSTATE.PARTOUTBOUND, text: '待入库', color: 'yellow' },
  { val: ORDERSTATE.PARTFINISHOUTBOUND, text: '待出入库', color: 'orange' },
  { val: ORDERSTATE.ENDINVENTORY, text: '已完成', color: 'green' },
  { val: ORDERSTATE.REFUSEEXAMINE, text: '拒绝', color: 'red' },
  { val: ORDERSTATE.CANCELEXAMINE, text: '取消审核', color: 'gray' },
  { val: ORDERSTATE.REVOKE, text: '已撤销', color: 'gray' },
];
// 物料发料单据审核状态常量
export const materialIssueAuditState = [
  { val: ORDERSTATE.WAITEXAMINE, text: '提交发料', color: 'black' },
  { val: ORDERSTATE.REFUSEEXAMINE, text: '拒绝发料', color: 'red' },
  { val: ORDERSTATE.CANCELEXAMINE, text: '取消审核', color: 'gray' },
];
// 物料回料单据状态常量
export const materialRecoveryState = [
  { val: ORDERSTATE.DRAFT, text: '草稿', color: 'blue' },
  { val: ORDERSTATE.WAITOUTBOUND, text: '待出库', color: 'yellow' },
  { val: ORDERSTATE.PARTOUTBOUND, text: '待入库', color: 'yellow' },
  { val: ORDERSTATE.PARTFINISHOUTBOUND, text: '待出入库', color: 'orange' },
  { val: ORDERSTATE.ENDINVENTORY, text: '已完成', color: 'green' },
  { val: ORDERSTATE.REVOKE, text: '已撤销', color: 'gray' },
];
// 工序审核状态常量
export const processAutditState = [
  { val: ORDERSTATE.PROCESSAUDITWAITSUBMIT, text: '待提交', color: 'gray' },
  { val: ORDERSTATE.PROCESSAUDITWAITAUDIT, text: '待审核', color: 'orange' },
  { val: ORDERSTATE.PROCESSAUDITCONSENT, text: '已同意', color: 'green' },
  { val: ORDERSTATE.PROCESSAUDITREJECT, text: '已拒绝', color: 'red' },
];

// 设计款状态
export const DESIGN_STATUS = {
  INDESIGN: 2, // 设计中
  WAIT: 3, // 待确定
  MODIFY: 4, // 修改中
  APPROVED: 5, // 审核通过
  CANCEL: 9, // 取消
};
// 设计款状态列表
export const designProState = [
  {
    val: DESIGN_STATUS.INDESIGN,
    text: '设计中',
    color: 'yellow',
    tc: '#FF8F1F',
    bg: '#FFEEDC',
  },
  {
    val: DESIGN_STATUS.WAIT,
    text: '待确定',
    color: 'yellow',
    tc: '#FF8F1F',
    bg: '#FFEEDC',
    orderCountField: 'toBeConfirmedCount',
  },
  {
    val: DESIGN_STATUS.MODIFY,
    text: '修改中',
    color: 'yellow',
    tc: '#FF8F1F',
    bg: '#FFEEDC',
    orderCountField: 'underEditCount',
  },
  {
    val: DESIGN_STATUS.APPROVED,
    text: '审核通过',
    color: 'green',
    tc: '#04C160',
    bg: '#D6F9E7',
  },
  {
    val: DESIGN_STATUS.CANCEL,
    text: '取消',
    color: 'gray',
    tc: '#979797',
    bg: '#EAEAEA',
  },
];

export const StateInfo = [
  { name: '正常流水', state: 2, isRevoke: 0, color: '#00b42a' },
  { name: '已撤销', state: 0, isRevoke: 1, recordType: 0, color: '#86909c' },
  {
    name: '撤销冲抵',
    state: 1,
    isRevoke: 1,
    recordType: 1,
    color: '#f53f3f',
  },
];

// 生产单-bom的发料状态
export const bomIssueState = [
  { val: 2, text: '无需发料', color: 'black' },
  { val: 1, text: '发料中', color: 'orange' },
  { val: 3, text: '发料结束', color: 'green' },
];

// 默认菜单常量
export const defaultOrderState = [{ val: 0, text: '默认' }];
export default {
  ORDERSTATE,
  // stockFlowState,
  materialInventoryState,
  finishedInventoryState,
  finishedTransferState,
  materialTransferState,
  materialPickingState,
  materialReturnState,
  outboundOrderState,
  goodsReworkOrderState,
  defaultOrderState,
  borrowOrderState,
  backOrderState,
  purchaseRetailState,
  deliveryOrderState,
  materialSendState,
  materialIssueAuditState,
  materialRecoveryState,
  processAutditState,
  StateInfo,
  bomIssueState,
  DESIGN_STATUS,
  designProState,
};
